import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { ProductInventoryService } from 'common/data';
import { sourceOfChange } from 'common/constants';

class ProductInventoryStore extends BaseStore {
	constructor(rootStore) {
		super(new ProductInventoryService(rootStore.app.baasic.apiClient));
	}

	@action async createBatch(productInventoryBatch, sourceOfChange) {
		const response = await this.service.createBatch(productInventoryBatch, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action
	findProductInventory = async filter => {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return response.data;
	};

	@action
	async sync(filter) {
		const response = await this.service.sync(filter);
		if (filter) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	}

	@action
	async syncWithWms(params, sourceOfChange) {
		const response = await this.service.syncWithWms(params, sourceOfChange);
		return response;
	}

	@action
	async syncInventoryForAllWarehouses(params, sourceOfChange) {
		const response = await this.service.syncInventoryForAllWarehouses(params, sourceOfChange);
		return response;
	}

	@action
	async syncInventoryForSeller(params, sourceOfChange) {
		const response = await this.service.syncInventoryForSeller(params, sourceOfChange);
		return response;
	}

	@action
	async exportInventoryByDate(params, sourceOfChange) {
		const response = await this.service.exportInventoryByDate(params, sourceOfChange);
		return response;
	}
}

export default ProductInventoryStore;
